import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import Toolbar from '@material-ui/core/Toolbar';
import Collapse from '@material-ui/core/Collapse';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './Container.scss';

@withWidth()
@withStyles(s)
export default class ToolbarContainer extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    expander: PropTypes.bool,
    styled: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    loading: PropTypes.bool,
  };

  static defaultProps = {
    styled: false,
    children: null,
    className: '',
    expander: false,
    width: '',
    loading: false,
  };

  state = {
    isExpanderOpen: false,
  };

  toggleExpander = () => {
    this.setState(prevState => ({
      isExpanderOpen: !prevState.isExpanderOpen,
    }));
  };

  render() {
    const {
      className,
      expander,
      children,
      width,
      styled,
      loading,
      ...rest
    } = this.props;
    const { isExpanderOpen } = this.state;

    return (
      <Toolbar
        className={classNames(s.toolbar, className, {
          [s.toolbarNew]: styled,
          [s.loading]: loading,
        })}
        {...rest}
      >
        {expander && children && width && !isWidthUp('sm', width) ? (
          <Collapse
            className={s.collapser}
            in={isExpanderOpen}
            collapsedHeight="20px"
          >
            <button
              data-test-id="bRzyvy8wFLQ19UDgggclt"
              className={s.collapseBtn}
              type="submit"
              onClick={this.toggleExpander}
            >
              {isExpanderOpen ? 'Close' : 'Open'} actions
            </button>
            {children}
          </Collapse>
        ) : (
          children
        )}
      </Toolbar>
    );
  }
}
